import { API, graphqlOperation } from "aws-amplify";
import { deleteEndorsement as deleteEndorsementMutation } from "../graphql/mutations";

export default async function deleteEndorsement(id) {
    await API.graphql(graphqlOperation(deleteEndorsementMutation, { input: {id: id}}))
}